var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleItemDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 122,
    viewBox: "0 0 162 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 121,
    rx: 4.5,
    fill: "#F8F8F8",
    stroke: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 46,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 53,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 60,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 80,
    width: 36,
    height: 9,
    rx: 4.5,
    fill: "#68C598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 33,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 33H26V78H71V33ZM69.0583 35.0254H28.0264V76.0879H69.0583V35.0254Z",
    fill: "#68C598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.063 64.2761L43.1472 50.9023L30.29 70.1881H47.9247L47.8569 70.2849H65.8569L56.8569 57.4277L52.063 64.2761Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4885 53.5848C62.3619 53.5848 64.6913 51.2791 64.6913 48.435C64.6913 45.5908 62.3619 43.2852 59.4885 43.2852C56.615 43.2852 54.2856 45.5908 54.2856 48.435C54.2856 51.2791 56.615 53.5848 59.4885 53.5848Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleItemDisplay);
export default __webpack_public_path__ + "static/media/single-item-display.9eb611f7d7fc13c6a25bc14a33ac277c.svg";
export { ForwardRef as ReactComponent };